/**
 * loadVersionToDraft - טעינת גירסה לטיוטה הנוכחית (current)
 * Pure function - מחזיר Redux action
 * @param {Object} version - אובייקט הגירסה
 */
export const loadVersionToDraft = (version) => {
    console.log('📥 Loading version to draft:', version.versionId);

    return {
        type: 'LOAD_VERSION_TO_DRAFT',
        payload: {
            widgets: version.widgets || [],
            settings: version.settings || { bgColor: '#fcfbfa', bgImage: '' },
            versionId: version.versionId
        }
    };
};
